<template>
  <div class="screen-full">
    <div class="head-box">
      <h1>{{ data.title }}</h1>
    </div>
    <div class="content-box">
      <h3><span style="float: left;font-size:24px;">答题倒计时：</span>
        <a-statistic-countdown
          :value="deadline"
          style="width:150px;float: left;"
        />
      </h3>
      <div class="answer-box">
        <span v-if="question !== null">
          <h4><b>{{ question.num }}、</b>{{ question.question }}</h4>
          <div v-if="question.img !== null" style="text-align: center;">
            <img style="width:120px;height:120px;" :src="question.img"/>
          </div>
          <div v-show="question.video !== null" style="text-align: center;">
            <video width="500" height="300" id="videoPlay" ref="videoUrl" controlsList="nodownload nofullscreen noremoteplayback">
                <source :src="question.video" type="video/mp4">
                <source :src="question.video" type="video/ogg">
                您的浏览器不支持 video 标签。
            </video><br/>
            <a-button @click="playVideo" icon="play-circle">{{ timeSecond === 0 ? '开始播放' : '重新播放' }}</a-button>
          </div>
          <div v-if="question.type === 1">
            <a-radio-group v-model="question.answer">
              <a-radio style="margin-bottom: 10px;" v-if="question.selectOne !== null" :style="question.selectType === 1 ? radioStyle : {}" value="0">
                A. <span v-if="question.selectType === 1">{{ question.selectOne }}</span>
                <img style="width:120px;height:120px;" v-else :src="question.selectOne"/>
              </a-radio>
              <a-radio style="margin-bottom: 10px;" v-if="question.selectTwo !== null" :style="question.selectType === 1 ? radioStyle : {}" value="1">
                B. <span v-if="question.selectType === 1">{{ question.selectTwo }}</span>
                <img style="width:120px;height:120px;" v-else :src="question.selectTwo"/>
              </a-radio>
              <a-radio style="margin-bottom: 10px;" v-if="question.selectThree !== null" :style="question.selectType === 1 ? radioStyle : {}" value="2">
                C. <span v-if="question.selectType === 1">{{ question.selectThree }}</span>
                <img style="width:120px;height:120px;" v-else :src="question.selectThree"/>
              </a-radio>
              <a-radio style="margin-bottom: 10px;" v-if="question.selectFour !== null" :style="question.selectType === 1 ? radioStyle : {}" value="3">
                D. <span v-if="question.selectType === 1">{{ question.selectFour }}</span>
                <img style="width:120px;height:120px;" v-else :src="question.selectFour"/>
              </a-radio>
              <a-radio style="margin-bottom: 10px;" v-if="question.selectFive !== null" :style="question.selectType === 1 ? radioStyle : {}" value="4">
                E. <span v-if="question.selectType === 1">{{ question.selectFive }}</span>
                <img style="width:120px;height:120px;" v-else :src="question.selectFive"/>
              </a-radio>
              <a-radio style="margin-bottom: 10px;" v-if="question.selectSix !== null" :style="question.selectType === 1 ? radioStyle : {}" value="5">
                F. <span v-if="question.selectType === 1">{{ question.selectSix }}</span>
                <img style="width:120px;height:120px;" v-else :src="question.selectSix"/>
              </a-radio>
            </a-radio-group>
          </div>
          <div v-if="question.type === 2">
            <a-checkbox-group v-model="question.answer">
                <a-row>
                  <a-col style="margin-bottom: 20px;" :span="question.selectType === 1 ? 24 : 8" v-if="question.selectOne !== null">
                    <a-checkbox value="0">
                      A. <span v-if="question.selectType === 1">{{ question.selectOne }}</span>
                        <img style="width:80px;height:80px;" v-else :src="question.selectOne"/>
                    </a-checkbox>
                  </a-col>
                  <a-col style="margin-bottom: 20px;"  :span="question.selectType === 1 ? 24 : 8" v-if="question.selectTwo !== null">
                    <a-checkbox value="1">
                      B. <span v-if="question.selectType === 1">{{ question.selectTwo }}</span>
                        <img style="width:80px;height:80px;" v-else :src="question.selectTwo"/>
                    </a-checkbox>
                  </a-col>
                  <a-col style="margin-bottom: 20px;"  :span="question.selectType === 1 ? 24 : 8" v-if="question.selectThree !== null">
                    <a-checkbox value="2">
                      C. <span v-if="question.selectType === 1">{{ question.selectThree }}</span>
                        <img style="width:80px;height:80px;" v-else :src="question.selectThree"/>
                    </a-checkbox>
                  </a-col>
                  <a-col style="margin-bottom: 20px;"  :span="question.selectType === 1 ? 24 : 8" v-if="question.selectFour !== null">
                    <a-checkbox value="3">
                      D. <span v-if="question.selectType === 1">{{ question.selectFour }}</span>
                        <img style="width:80px;height:80px;" v-else :src="question.selectFour"/>
                    </a-checkbox>
                  </a-col>
                  <a-col style="margin-bottom: 20px;"  :span="question.selectType === 1 ? 24 : 8" v-if="question.selectFive !== null">
                    <a-checkbox value="4">
                      E. <span v-if="question.selectType === 1">{{ question.selectFive }}</span>
                        <img style="width:80px;height:80px;" v-else :src="question.selectFive"/>
                    </a-checkbox>
                  </a-col>
                  <a-col style="margin-bottom: 20px;"  :span="question.selectType === 1 ? 24 : 8" v-if="question.selectSix !== null">
                    <a-checkbox value="5">
                      F. <span v-if="question.selectType === 1">{{ question.selectSix }}</span>
                        <img style="width:80px;height:80px;" v-else :src="question.selectSix"/>
                    </a-checkbox>
                  </a-col>
                </a-row>
              </a-checkbox-group>
          </div>
          <div v-if="question.type === 3">
            <a-radio-group v-model="question.answer">
              <a-radio :style="radioStyle" value="1">
                对
              </a-radio>
              <a-radio :style="radioStyle" value="0">
                错
              </a-radio>
            </a-radio-group>
          </div>
          <div v-if="question.type === 4">
            <a-input v-model="question.answer" style="margin-top:20px;" placeholder="请输入答案" />
          </div>
          <div v-if="question.type === 5">
            <a-textarea v-model="question.answer" placeholder="请输入答案" :rows="4" />
          </div>
          <div v-if="question.type === 6">
            <p>已播放：{{ calTime() }}</p>
            <div style="width:100%;height:50px;">
              <div class="score-red-css" @click="changeScore('red', '+1')">+1</div>
              <div class="score-red-css" @click="changeScore('red', '+2')">+2</div>
              <div class="score-red-css" @click="changeScore('red', '+3')">+3</div>
              <div class="score-res-css" @click="again()">重做</div>
              <div class="score-blue-css" @click="changeScore('blue', '+1')">+1</div>
              <div class="score-blue-css" @click="changeScore('blue', '+2')">+2</div>
              <div class="score-blue-css" @click="changeScore('blue', '+3')" style="margin-right:0">+3</div>
            </div>
            <!-- <div style="width:100%;height:50px;">
              <div class="type-red-css" @click="changeScore('red', '警告')">警告</div>
              <div class="type-red-css" @click="changeScore('red', '严重警告')">严重警告</div>
              <div class="type-red-css" @click="changeScore('red', '犯规败')">犯规败</div>
              <div class="type-red-css" @click="changeScore('red', '起手式得分')">起手式得分</div>
              <div class="type-blue-css" @click="changeScore('blue', '起手式得分')">起手式得分</div>
              <div class="type-blue-css" @click="changeScore('blue', '犯规败')">犯规败</div>
              <div class="type-blue-css" @click="changeScore('blue', '严重警告')">严重警告</div>
              <div class="type-blue-css" @click="changeScore('blue', '警告')">警告</div>
            </div> -->
            <div style="width:100%;">
              <div class="type-red-css" @click="changeScore('red', '警告')">警告</div>
              <div class="type-red-css" @click="changeScore('red', '严重警告')">严重警告</div>
              <div class="type-red-css" @click="changeScore('red', '犯规败')">犯规败</div>
              <div class="type-red-css" @click="changeScore('red', '起手式得分')">起手式得分</div>
              <div class="type-red-css" @click="changeScore('red', '出界')">出界</div>
              <div class="type-red-css" @click="changeScore('red', '倒地')">倒地</div>
              <div class="type-red-css" @click="changeScore('red', '回避比赛')">回避比赛</div>
              <div class="type-red-css" @click="changeScore('red', '抓对手')">抓对手</div>
              <div class="type-red-css" @click="changeScore('red', '推对手')">推对手</div>
              <div class="type-red-css" @click="changeScore('red', '阻碍')">阻碍</div>
              <div class="type-red-css" @click="changeScore('red', '攻击下肢')">攻击下肢</div>
              <div class="type-red-css" @click="changeScore('red', '分开后攻击')">分开后攻击</div>
              <div class="type-red-css" @click="changeScore('red', '手功击头')">手功击头</div>
              <div class="type-red-css" @click="changeScore('red', '膝部顶撞或攻击')">膝部顶撞或攻击</div>
              <div class="type-red-css" @click="changeScore('red', '攻击倒地运动员')">攻击倒地运动员</div>
              <div class="type-red-css" @click="changeScore('red', '猴踢躯干')">猴踢躯干</div>
              <div class="type-red-css" @click="changeScore('red', '贴靠击打后部')">贴靠击打后部</div>
              <div class="type-red-css" @click="changeScore('red', '不良言行')">不良言行</div>
            </div>
            <div style="width:100%;">
              <div class="type-blue-css" @click="changeScore('blue', '起手式得分')">起手式得分</div>
              <div class="type-blue-css" @click="changeScore('blue', '犯规败')">犯规败</div>
              <div class="type-blue-css" @click="changeScore('blue', '严重警告')">严重警告</div>
              <div class="type-blue-css" @click="changeScore('blue', '警告')">警告</div>
              <div class="type-blue-css" @click="changeScore('blue', '出界')">出界</div>
              <div class="type-blue-css" @click="changeScore('blue', '倒地')">倒地</div>
              <div class="type-blue-css" @click="changeScore('blue', '回避比赛')">回避比赛</div>
              <div class="type-blue-css" @click="changeScore('blue', '抓对手')">抓对手</div>
              <div class="type-blue-css" @click="changeScore('blue', '推对手')">推对手</div>
              <div class="type-blue-css" @click="changeScore('blue', '阻碍')">阻碍</div>
              <div class="type-blue-css" @click="changeScore('blue', '攻击下肢')">攻击下肢</div>
              <div class="type-blue-css" @click="changeScore('blue', '分开后攻击')">分开后攻击</div>
              <div class="type-blue-css" @click="changeScore('blue', '手功击头')">手功击头</div>
              <div class="type-blue-css" @click="changeScore('blue', '膝部顶撞或攻击')">膝部顶撞或攻击</div>
              <div class="type-blue-css" @click="changeScore('blue', '攻击倒地运动员')">攻击倒地运动员</div>
              <div class="type-blue-css" @click="changeScore('blue', '猴踢躯干')">猴踢躯干</div>
              <div class="type-blue-css" @click="changeScore('blue', '贴靠击打后部')">贴靠击打后部</div>
              <div class="type-blue-css" @click="changeScore('blue', '不良言行')">不良言行</div>
            </div>
            <div style="width:100%;min-height:50px;border:1px solid #ccc;">
              <div v-if="question.answer">
                <span v-for="(item,index) in question.answer" :key="index">
                  {{ item.player === 'red' ? '红方' : '蓝方' }}{{ item.result }}；
                </span>
              </div>
            </div>
          </div>
          <div>
            <div class="btn-css" @click="changeSubject(-1)">上一题</div>
            <div class="btn-css" @click="sumbitQues()">提交本题</div>
            <div class="btn-css" @click="changeSubject(1)">下一题</div>
          </div>
        </span>
      </div>
      <div class="indexes-box">
        <div v-for="(item,index, num) in mapData" :key="index" style="overflow: hidden;margin-bottom:20px;">
          <h4>{{ num + 1 }}、{{ index }}</h4>
          <div v-for="(it,ind) in item" :key="ind" class="item-css" @click="changeItem(it)" :style="{background: currNum === it.num ? '#ced8e7' : '#fff' }">
            {{ it.num }}
          </div>
        </div>
      </div>
    </div>
        <!-- <div v-show="!isFullscreen" @click="handleFullScreen">全屏模式</div>
        <div v-show="isFullscreen" @click="handleFullScreen">退出全屏</div> -->
    </div>
</template>

<script>
import screenfull from 'screenfull' // 引入依赖
export default {
  components: {
  },
  data () {
    return {
      programId: Number(this.$route.query.programId),
      deadline: Date.now() + 1000 * 60 * 60,
      data: {
        title: ''
      },
      question: null,
      mapData: {},
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      list: [],
      currNum: 1,
      timeSecond: 0,
      timer: null,
      isFullscreen: false // 是否全屏
    }
  },
  created () {
    if (!localStorage.getItem('chenk_time_joinid_' + this.$route.query.joinId)) {
      localStorage.setItem('chenk_time_joinid_' + this.$route.query.joinId, Date.now() + 1000 * 60 * 60)
    }
    this.deadline = parseInt(localStorage.getItem('chenk_time_joinid_' + this.$route.query.joinId))

    let that = this
    this.$info({
      title: '您即将进入全屏答题模式，请不要退出全屏，当您退出全屏时，表示你已答题完毕！',
      okText: '开始答题',
      onOk () {
        that.handleFullScreen()
      }
    })
    this.findData()
    this.findCheck()
    this.init()
    this.stopF5Refresh()
  },
  beforeDestroy () {
    this.destroy()
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  },
  methods: {
    findData () {
      this.$api.examin.examinPointDetail({id: this.$route.query.id}).then(res => {
        if (res.status === 0) {
          this.data = res.data
          this.data.company = JSON.parse(res.data.company)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    findCheck () {
      this.list = []
      this.$api.examin.checkList({joinId: this.$route.query.joinId, pointId: this.$route.query.id, projectId: this.$route.query.projectId}).then(res => {
        if (res.status === 0) {
          this.mapData = res.data
          for (let key in this.mapData) {
            this.mapData[key].forEach(element => {
              if (element.typeId === 2) {
                element.answer = element.answer.split(',')
              } else if (element.typeId === 6) {
                element.answer = JSON.parse(element.answer)
              } else {
                element.answer = element.answer
              }
              this.list.push(element)
            })
          }
          this.calQuestion()
          this.judgeList()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    calQuestion () {
      let that = this
      this.question = this.list.filter(function (item) {
        return item.num === that.currNum
      })[0]
      if (this.question.video !== null) {
        this.$refs.videoUrl.src = this.question.video
        this.$refs.videoUrl['disablePictureInPicture'] = true
      }
    },
    changeSubject (type) {
      if (this.currNum <= 1 && type < 0) {
        this.$message.info('没有上一题了')
        return
      }
      if (this.currNum >= this.list.length && type > 0) {
        this.$message.info('没有下一题了')
        return
      }
      if (type > 0) {
        this.currNum++
      } else {
        this.currNum--
      }

      this.calQuestion()
    },
    playVideo () {
      this.again()
      var videoElement = document.getElementById('videoPlay')
      videoElement.play()
      this.timeSecond = videoElement.currentTime
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
      var _this = this // 声明一个变量指向Vue实例this，保证作用域一致
      this.timer = setInterval(function () {
        _this.timeSecond = videoElement.currentTime
        _this.timeSecond++
        if (videoElement.ended) {
          clearInterval(_this.timer)
          _this.timer = null
        }
      }, 1000)
    },
    changeItem (it) {
      this.currNum = it.num
      this.question = it
      if (it.video !== null) {
        this.$refs.videoUrl.src = it.video
        this.$refs.videoUrl['disablePictureInPicture'] = true
      }
    },
    handleFullScreen () {
      if (!screenfull.isEnabled) {
        this.$message.info('您的浏览器版本过低，不支持全屏浏览')
        return false
      }
      screenfull.toggle()
    },
    change () {
      this.isFullscreen = screenfull.isFullscreen
    },
    changeScore (type, result) {
      if (this.timeSecond === 0) {
        this.$message.info('您视频还未开始播放')
        return
      }
      if (this.timer === null) {
        this.$message.info('该视频播放已结束')
        return
      }
      if (!this.question.answer) {
        this.question.answer = [{
          time: this.calTime(),
          player: type,
          result: result
        }]
      } else {
        this.question.answer.push({
          time: this.calTime(),
          player: type,
          result: result
        })
      }
    },
    again () {
      this.question.answer = []
      this.$forceUpdate()
      this.timeSecond = 0
      clearInterval(this.timer)
      if (this.question.video !== null) {
        this.$refs.videoUrl.src = this.question.video
      }
    },
    calTime () {
      let result = this.timeSecond
      let m =
        Math.floor((result / 60) % 60) < 10
          ? '0' + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60)

      let s =
        Math.floor(result % 60) < 10
          ? '0' + Math.floor(result % 60)
          : Math.floor(result % 60)
      return m + ':' + s
    },
    sumbitQues () {
      let that = this
      console.log(Date.now() - this.deadline)
      if ((Date.now() - this.deadline) > 0) {
        this.$message.info('作答时间已到，停止作答')
        that.$success({
          title: '作答时间已到，停止作答',
          okText: '退出考试',
          onOk () {
            that.$router.push('/ActivityCheck' + '?id=' + that.$route.query.id + '&programId=' + that.$route.query.programId)
          }
        })
        return
      }
      if (!this.question.answer && this.question.answer !== 0) {
        this.$message.info('你还没有作答！')
        return
      }
      let valData = {
        pointId: this.$route.query.id,
        joinId: this.$route.query.joinId,
        questionId: this.question.id,
        projectId: this.$route.query.projectId,
        typeId: this.question.type,
        answer: this.question.type === 2 || this.question.type === 6 ? JSON.stringify(this.question.answer) : this.question.answer
      }
      this.$api.examin.examinAnswer(valData).then(res => {
        if (res.status === 0) {
          this.question.isAnswer = 1
          this.$message.success('提交成功')
          this.changeSubject(1)
          this.judgeList()
        }
      }).catch(err => {
        console.log(err)
      })

      console.log(this.question)
    },
    judgeList () {
      let arr = this.list.filter(function (item) {
        return item.isAnswer === null
      })
      let that = this
      if (arr.length === 0) {
        this.$api.examin.answerScore({
          pointId: this.$route.query.id,
          joinId: this.$route.query.joinId,
          projectId: this.$route.query.projectId
        }).then(res => {
          if (res.status === 0 && res.data !== null) {
            that.$success({
              title: '答题已全部完成',
              // JSX support
              content: (
                <div>
                  <p>作答分数：<b>{ res.data }分</b></p>
                </div>
              ),
              okText: '退出考试',
              onOk () {
                that.$router.push('/ActivityCheck' + '?id=' + that.$route.query.id + '&programId=' + that.$route.query.programId)
              }
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    init () {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.change)
      }
    },
    destroy () {
      if (screenfull.isEnabled) {
        screenfull.off('change', this.change)
      }
    },
    stopF5Refresh () {
      document.onkeydown = function (e) {
        var evt = window.event || e
        var code = evt.keyCode || evt.which
        // 屏蔽F1---F12
        if (code > 111 && code < 124) {
          if (evt.preventDefault) {
            evt.preventDefault()
          } else {
            evt.keyCode = 0
            evt.returnValue = false
          }
        }
      }
      // 禁止鼠标右键菜单
      document.oncontextmenu = function () {
        return false
      }
      // 阻止后退的所有动作，包括 键盘、鼠标手势等产生的后退动作。
      history.pushState(null, null, window.location.href)
      window.addEventListener('popstate', function () {
        history.pushState(null, null, window.location.href)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.screen-full{
  width: 100%;
}
.head-box{
  background: #244e8f;
  height: 100px;
  line-height: 100px;
  width: 100%;
  color:white;
  text-align: center;
}
.head-box h1{
  color:white;
}
.content-box{
  width: 1200px;
  margin: 0 auto;
  height: 600px;
  margin-top: 40px;
}
.content-box h3{
  width: 100%;
  height: 40px;
}
.answer-box{
  width: 58%;
  float: left;
  border: 1px solid #244e8f;
  border-radius:5px;
  padding: 20px;
}
.indexes-box{
  width: 40%;
  float: right;
  border: 1px solid #244e8f;
  border-radius:5px;
  padding: 20px;
}
.item-css{
  width: 40px;
  height: 30px;
  border:1px solid #ccc;
  line-height: 30px;
  text-align: center;
  float: left;
  margin-right: 3px;
  border-radius:3px;
  cursor: pointer;
}
.score-red-css{
  width: 40px;
  height: 40px;
  background: red;
  text-align: center;
  line-height: 40px;
  color: white;
  font-weight: bold;
  border-radius:50%;
  font-size: 20px;
  float: left;
  margin-right: 52px;
  cursor: pointer;
}
.score-res-css{
  width: 100px;
  height: 30px;
  background: #244e8f;
  text-align: center;
  line-height: 30px;
  color: white;
  font-weight: bold;
  border-radius:5px;
  font-size: 16px;
  float: left;
  margin-right: 40px;
  margin-top: 5px;
  cursor: pointer;
}
.score-blue-css{
  width: 40px;
  height: 40px;
  background: blue;
  text-align: center;
  line-height: 40px;
  color: white;
  font-weight: bold;
  border-radius:50%;
  font-size: 20px;
  float: left;
  margin-right: 52px;
  cursor: pointer;
}
.type-red-css{
  border: 1px solid red;
  text-align: center;
  color:red;
  border-radius: 5px;
  float: left;
  padding: 5px;
  margin-right: 20px;
  cursor: pointer;
}
.type-blue-css{
  border: 1px solid blue;
  text-align: center;
  color:blue;
  border-radius: 5px;
  float: right;
  padding: 5px;
  margin-left: 20px;
  cursor: pointer;
}
.btn-css{
  width: 130px;
  border: 1px solid #244e8f;
  color: #244e8f;
  float: left;
  margin: 40px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/ActivityAnswer.vue